/**
 * @fileoverview Helper module that splits the creation of LargeDialog and SmallDialog
 * @author Sahil Parikh (sparikh@yext.com)
 */
// @ts-nocheck
goog.declareModuleId('yext.ui.components.modal.Dialog');

import {Modal, ModalProps} from '/ui/components/modal/modal';

import * as styles from '/ui/components/modal/modal.module.scss';

/**
 * NOTE(amullings): There are only a couple of places passing React elements as
 * the title. If we get rid of those, we can remove React.ReactElement from the type.
 *
 * @typedef {{
 *   children?: ?,
 *   onHideDialog: (function(): void),
 *   show?: boolean,
 *   callToAction?: !Object,
 *   tid?: string,
 *   title: (string|React.ReactElement),
 *   hideTitle?: boolean,
 *   hideCloseButton?: boolean,
 *   zIndex?: number,
 *   pinToTop?: boolean,
 *   enableBackgroundScroll?: boolean,
 * }}
 */
export let DialogProps;

/**
 * @param {!DialogProps} props props to be passed to the Modal Component
 * @return {React.ReactElement} constructed small dialog modal
 */
export function SmallDialog(props) {
  const modalProps = /** @type {!ModalProps} */({
    dialogSize: 'small',
    onHideModal: props.onHideDialog,
    ...props,
  });
  return React.createElement(Modal, modalProps, props.children);
}

/**
 * @param {!DialogProps} props props to be passed to the Modal Component
 * @return {React.ReactElement} constructed large dialog modal
 */
export function LargeDialog(props) {
  const modalProps = /** @type {!ModalProps} */({
    dialogSize: 'large',
    onHideModal: props.onHideDialog,
    ...props,
  });
  return React.createElement(Modal, modalProps, props.children);
}

/**
 * @param {!DialogProps} props props to be passed to the Modal Component
 * @return {React.ReactElement} constructed full width dialog modal
 */
export function FullWidthDialog(props) {
  const modalProps = /** @type {!ModalProps} */({
    dialogSize: 'fullwidth',
    onHideModal: props.onHideDialog,
    ...props,
  });
  return React.createElement(Modal, modalProps, props.children);
}

/**
 * @param {!DialogProps} props props to be passed to the Modal Component
 * @return {React.ReactElement} constructed full page dialog modal
 */
export function FullPageDialog(props) {
  const modalProps = /** @type {!ModalProps} */({
    dialogSize: 'fullpage',
    onHideModal: props.onHideDialog,
    ...props,
  });
  return React.createElement(Modal, modalProps, props.children);
}

/**
 * @param {boolean|function(): boolean} initiallyOpen
 * @return {{
 *   isDialogShown: boolean,
 *   showDialog: !function(),
 *   hideDialog: !function(),
 *   toggleDialog: !function(),
 * }}
 */
export function useDialogState(initiallyOpen) {
  const [isDialogOpen, setExpanded] = React.useState(initiallyOpen);
  return {
    isDialogShown: isDialogOpen,
    showDialog: () => setExpanded(true),
    hideDialog: () => setExpanded(false),
    toggleDialog: () => setExpanded(expanded => !expanded),
  };
}

export function DialogPadding({children}) {
  return (
    <div className={styles.dialogPadding}>
      {children}
    </div>
  );
}
